<template>
    <rpm-table
        title="Editar Permissões"
        :columns="columns"
        :pagination="pagination"
        @change-page="getPermissionsByID"
        :data="permissionsList"
        :loading="loading"
    >
        <template #functions>
            <section class="flex flex-row-reverse w-full">
                <rpm-button
                    class="w-6 h-6 rounded"
                    font-size="text-sm"
                    icon="fa-solid fa-plus"
                    @click="openAddModal()"
                ></rpm-button>
            </section>
        </template>

        <template #actions="{item}">
            <rpm-button
                icon="fa-solid fa-trash"
                color="red-hover"
                tooltip-text="Excluir"
                @click="openDeleteModal(item)"
            ></rpm-button>
        </template>
    </rpm-table>

    <rpm-modal
        header="Adicionar permissão"
        class="flex flex-col gap-8"
        persist
        :open="modalAdd"
        @close="modalAdd = false"
    >
        <rpm-input
            type="multiselect"
            label="Permissões"
            placeholder="Permissões"
            required
            v-model="form.permissions"
            :options="remainingPermissions"
            optionLabel="name"
            optionValue="id"
            :errors="errors.permissions"
        ></rpm-input>
        <template #buttons>
            <rpm-button
                label="Confirmar"
                @click="updatePermissions()"
            ></rpm-button>
        </template >
    </rpm-modal>

    <rpm-modal
        header="Remover Permissão?"
        :open="modalDelete"
        @close="modalDelete = false"
        size="max-w-xl"
    >
        <template #buttons>
            <rpm-button
                color="red"
                label="Excluir"
                @click="deletePermissions()"
            ></rpm-button>
        </template>
    </rpm-modal>
</template>
<script>

import RpmTable from '#components/RpmTable';
import RpmModal from '#components/RpmModal';
import Card from '#components/Card';
import roleRepository from '#repositories/roleRepository';
import { request } from '#repositories/repository';
import { getErrors } from '#functions/validator';

export default {
    name: "EditPermissions",
    components: {
        RpmTable,
        RpmModal,
        Card,
    },
    data() {
        return {
            loading: false,
            form: {},
            errors: {},
            columns: [
                {
                    field: "name",
                    label: "Permissões"
                },
              {
                field: 'description',
                label: 'Descrição'
              }
            ],
            pagination: {
                page: this.$route.query.page ?? 1,
                per_page: 10,
                last_page: 0,
                links: []
            },
            permissionsList: [],
            remainingPermissions: [],
            modalAdd: false,
            modalDelete: false,

        }
    },
    props: {id: {}},
    methods: {
        async getRemainingPermissions() {
            this.loading = true;
            this.remainingPermissions = (await roleRepository.getRemainingPermissions(this.$route.params.id));
            this.loading = false;
        },

        async getPermissionsByID(page = 0, useLoading = true) {
            if (page && page !== 0) this.pagination.page = page;
            if(useLoading) this.loading = true;
            this.permissionsList = request.pagination(
                await roleRepository.getPermissionsByID(this.$route.params.id, this.pagination),
                this.pagination
            );
            if(useLoading) this.loading = false;
        },

        openAddModal() {
            this.modalAdd = true;
            this.form.permissions = [];
        },

        openDeleteModal(item) {
            this.modalDelete = true;
            this.form.permission_id = item.id;
        },

        updatePermissions() {
            roleRepository.addPermissions(this.form).then(() => {
                this.getPermissionsByID();
                this.getRemainingPermissions();
                this.modalAdd = false;
                this.$notify("Permissões alterados com sucesso!", "success");
            }).catch((response) => {
                getErrors(this.errors, response.errors);
            })
        },

        deletePermissions() {
            roleRepository.removePermissions(this.form).then(() => {
                this.getPermissionsByID();
                this.getRemainingPermissions();
                this.modalDelete = false;
                this.$notify("Permissão removida com sucesso!", "success");
            }).catch((response) => {
                getErrors(this.errors, response.errors);
            });
        },
    },
    mounted() {
        this.getRemainingPermissions();
        this.getPermissionsByID();
        this.form.role_id = this.$route.params.id;
    }
}
</script>